export default __webpack_public_path__ + "assets/images/2.e452e7.png";